"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useManagePlan = exports.getSelectedId = void 0;
const api_1 = require("core/api");
const SetupPaymentMethodContext_1 = require("core/api/models/SetupPaymentMethodContext");
const CustomerService_1 = require("core/api/services/CustomerService");
const utils_1 = require("core/utils");
const react_1 = require("react");
const react_router_1 = require("react-router");
const useRequest_1 = require("src/hooks/useRequest");
const getSelectedId = (paymentMethods, teamPlan) => {
    if (!teamPlan || !paymentMethods || paymentMethods.length === 0) {
        return;
    }
    const paymentMethodId = teamPlan?.metadata?.paymentMethodId;
    const matchPaymentMethod = paymentMethods.find((pm) => pm.id?.includes(paymentMethodId ?? ''));
    if (matchPaymentMethod) {
        return matchPaymentMethod.id;
    }
    return paymentMethods.find((pm) => pm.isDefault && pm.id.startsWith('stripe:'))?.id;
};
exports.getSelectedId = getSelectedId;
const useManagePlan = () => {
    const { teamId } = (0, react_router_1.useParams)();
    const { isProcessing, makeRequest } = (0, useRequest_1.useRequest)();
    const [liteTeam, setLiteTeam] = (0, react_1.useState)();
    const [teamPlan, setTeamPlan] = (0, react_1.useState)();
    const [paymentMethods, setPaymentMethods] = (0, react_1.useState)();
    const [selectedId, setSelectedId] = (0, react_1.useState)();
    const [addingMethod, setAddingMethod] = (0, react_1.useState)(false);
    const fetchPaymentMethods = async () => {
        const { data } = await makeRequest(async () => CustomerService_1.CustomerService.getMyPaymentMethods());
        setPaymentMethods(data?.paymentMethods ?? []);
    };
    const fetchTeamSubscription = async () => {
        const { data } = await makeRequest(async () => api_1.TeamService.getTeamSubscription(parseInt(teamId)));
        setLiteTeam(data?.team);
        setTeamPlan(data?.subscription);
    };
    const createPaymentMethod = async () => {
        if (!teamId) {
            return;
        }
        setAddingMethod(true);
        const { data } = await makeRequest(async () => CustomerService_1.CustomerService.setupPaymentMethod({
            context: SetupPaymentMethodContext_1.SetupPaymentMethodContext.TEAM,
            contextId: parseInt(teamId),
        }));
        if (data?.setupUrl) {
            (0, utils_1.redirectTo)(data.setupUrl);
        }
        setAddingMethod(false);
    };
    const setTeamSubscriptionPaymentMethod = async (paymentMethodId) => {
        if (!teamId) {
            return;
        }
        const { data } = await makeRequest(async () => api_1.TeamService.updateTeamSubscriptionPaymentMethod(parseInt(teamId), {
            paymentMethodId,
        }), 'Success');
        if (data?.success) {
            setSelectedId(paymentMethodId);
        }
    };
    (0, react_1.useEffect)(() => {
        Promise.all([fetchPaymentMethods(), fetchTeamSubscription()]);
    }, []);
    (0, react_1.useEffect)(() => {
        setSelectedId((0, exports.getSelectedId)(paymentMethods, teamPlan));
    }, [paymentMethods, teamPlan]);
    return {
        paymentMethods,
        liteTeam,
        teamPlan,
        isProcessing,
        createPaymentMethod,
        setTeamSubscriptionPaymentMethod,
        selectedId,
        addingMethod,
    };
};
exports.useManagePlan = useManagePlan;
